































import {
  QPage,
  QPageSticky,
  QBtn,
  QCard,
  QToolbar,
  QToolbarTitle,
  QHeader,
  QChatMessage,
  QIcon,
} from "quasar";
import { defineComponent, reactive, ref, watch } from "@vue/composition-api";
import { AIRequest, AIResponse, sendMessage } from "@/data/repos/aiassistant";
import { fetchUserInfo } from "@/modules/auth";
import { UserSessionResponse } from "@/data/repos/userInfo";
import router from "@/router";
import { MediaRecorder, register } from "extendable-media-recorder";
import { connect } from "extendable-media-recorder-wav-encoder";

export default defineComponent({
  components: {
    QPage,
    QPageSticky,
    QBtn,
    QCard,
    QToolbar,
    QToolbarTitle,
    QHeader,
    QChatMessage,
    QIcon,
  },
  props: {
    app: String,
    url: String,
  },
  setup(props) {
    const state = reactive({
      showAssistant: false,
      message: "",
      userInfo: {} as UserSessionResponse,
    });
    fetchUserInfo().then((resp) => (state.userInfo = resp));

    return state;
  },
});
